// GSAP Animations

$( document ).ready(function() { 
    console.log("animations.js READY");
  
  // RESPONSIVE FUNCTIONS:
  ScrollTrigger.matchMedia({
	
    // desktop: bootstrap "md"
  "(min-width: 768px)": function() {
    // setup animations and ScrollTriggers for screens 800px wide or greater (desktop) here...
    // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
    
    // ***** ANIMATE ABOUT > TIMELINE SECTIONS ******       
    if ($('.about-story__histories').length){     
      gsap.utils.toArray(".js_animateTimeline--container").forEach((container) => {
        let marker = container.querySelector(".js_animateMarker--element");
        let image = container.querySelector(".js_animateImage--element");
        let text = container.querySelector(".js_animateText--element");
        let tl = gsap.timeline({
          scrollTrigger: {
            start: "top bottom", 
            end: "bottom center", 
            scrub: true,
            trigger: container,
            toggleActions: "play pause resume reset", // onEnter, onLeave, onEnterBack, and onLeaveBack
            markers: false
          }
        });
        tl.fromTo(marker, 1, {height: "0%"}, {height: "100%"}, 1);      
        tl.fromTo(text, 0.5, {opacity: "0", top: "3em"}, {opacity: "1", top: "0"}, "-=1");  
        tl.fromTo(image, 0.5, {opacity: "0", top: "3em"}, {opacity: "1", top: "0"}, "-=1");      
      });    
    }
    
    
  },

    // mobile: bootstrap "sm"
  "(max-width: 767px)": function() {
    // The ScrollTriggers created inside these functions are segregated and get
    // reverted/killed when the media query doesn't match anymore. 
    
        // ***** PIN COLLECTION MULTIFILTERS ON MOBILE ******       
        if ( $('.template-collection .js_multifilter-container').length ) { 
          ScrollTrigger.create({
            trigger: ".js_subfilters-pin--pinTo",
            pin: ".js_subfilters-pin--pinEl",
            start: "top top",
            end: "bottom center",
            pinSpacing: false,
            toggleClass: 'subfilters-pinned',
            markers:false
          });      
        }
  },
	
  // all 
  "all": function() {
    // ScrollTriggers created here aren't associated with a particular media query,
    // so they persist.
  }
	
}); 
  
  

  
}); // end doc ready wrapper